<app-modal
  #checklistModal
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="'checklist-modal-title-' + paginationId"
  tabindex="-1">
  <header>
    <div class="d-flex justify-content-between">
      <h1
        class="title"
        [attr.id]="'checklist-modal-title-' + paginationId"
        #modalTitle
        tabindex="-1">
        {{ title }}
      </h1>
      <button
        type="button"
        (click)="onClose(false)"
        [class.disabled]="loadingChecklistItems"
        [disabled]="loadingChecklistItems"
        [attr.aria-label]="'Close ' + title + ' checklist'"
        class="material-symbols-outlined close-button">
        close
      </button>
    </div>
    <app-checklist-summary
      [checklistItems]="checklistItems"
      [isExpandedAll]="false"
      [showExpandBtn]="false"
      [attr.aria-label]="'Checklist summary: ' + checklistItems.length + ' total items'">
    </app-checklist-summary>
  </header>

  <app-modal-body>
    <app-paginated-cards
      *ngIf="checklistItems.length"
      [paginationId]="paginationId"
      [items]="checklistItems"
      [trackByProperty]="'updated'"
      [cardTemplate]="cardTemplate"
      [draggable]="false"
      [applyPadding]="false"
      role="list"
      [attr.aria-label]="title + ' checklist items, ' + checklistItems.length + ' items'">
    </app-paginated-cards>

    <ng-template #cardTemplate let-item="item">
      <app-checklist-item-card
        [loading]="loadingChecklistItems"
        [item]="item"
        [draggable]="false"
        [userHasWriteAccess]="canEdit"
        (itemCompleted)="updateItem($event)"
        (attachmentChanged)="onAttachmentChanged($event)"
        role="listitem"
        [attr.aria-label]="item.title">
      </app-checklist-item-card>
    </ng-template>
  </app-modal-body>

  <app-modal-footer>
    <app-button-rectangle
      [buttonTheme]="'white'"
      [class]="'button'"
      [fitToContainer]="true"
      [size]="'large'"
      [text]="T.common.close | translate"
      (clicked)="onClose(true)"
      [disabled]="loadingChecklistItems"
      [ariaLabel]="'Close ' + title + ' checklist'">
    </app-button-rectangle>
  </app-modal-footer>
</app-modal>
